import { useCallback } from "react";

// Try the ProductFruits JavaScript API (preferred — works even when their launcher button
// is hidden or not rendered). Fall back to clicking the DOM launcher as a secondary path.
function openViaApi() {
    if (typeof window === "undefined") return false;
    // ProductFruits v2 SDK exposes window.productFruits.api after initialization.
    const api = window.productFruits?.api;
    // Both names are tried because the SDK ships no types for inAppCenter and the shape
    // cannot be pinned down from the repo — the API lives in a remote script. Probing for a
    // function rather than truthiness also matters: calling a missing open() threw, which
    // aborted openViaApi() and stopped the launcher fallback below from ever running.
    const inAppCenter = api?.inAppCenter;
    for (const method of ["open", "show"]) {
        if (typeof inAppCenter?.[method] === "function") {
            inAppCenter[method]();
            return true;
        }
    }
    // Older SDK shape
    if (typeof api?.button?.showSidebarWidget === "function") {
        api.button.showSidebarWidget();
        return true;
    }
    if (typeof api?.button?.click === "function") {
        api.button.click();
        return true;
    }
    return false;
}

function openViaLauncher() {
    const el = document.querySelector(".button-launcher");
    if (el) {
        el.click();
        return true;
    }
    return false;
}

const useHelpCenter = () => {
    const openHelpCenter = useCallback(() => openViaApi() || openViaLauncher(), []);

    const isHelpCenterAvailable = () =>
        !!(window.productFruits?.api || document.querySelector(".button-launcher"));

    return { openHelpCenter, isHelpCenterAvailable };
};

export default useHelpCenter;
